import { Timesheet } from '../types/timers'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useTimers } from './timers'

const timesheetIndex = ref<null | number>(null)
const swapped = ref(false)
const timesheet = ref<Timesheet>()
const globalTimesheet = ref<Timesheet>()
export const useGlobalTimesheetInstance = defineStore('globalTimesheet', () => {
  const { resetOriginalTimers } = useTimers()
  const timesheetDate = computed(() => {
    if (typeof timesheet.value !== 'undefined') {
      return new Date(timesheet.value.date)
    } else {
      //fallback so things don't break
      return new Date()
    }
  })
  const timesheetDateString = computed(() => timesheet.value?.date ?? null)
  const swapTimecardTimersBack = async (options: { reset: boolean } = { reset: true }) => {
    console.log('not editing so go swap')
    swapped.value = false
    if (options.reset) {
      //swap timers back
      if (timesheetIndex.value !== null) {
        await resetOriginalTimers(timesheetIndex.value)
      }
      timesheetIndex.value = null
      timesheet.value = undefined
    }
  }

  return {
    timesheet,
    timesheetIndex,
    swapped,
    timesheetDate,
    timesheetDateString,
    swapTimecardTimersBack,
    globalTimesheet,
  }
})
